import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f6b3c856"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "uav-brochure" }
const _hoisted_2 = { class: "product-service" }
const _hoisted_3 = { class: "product-select" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "product-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "zh-title" }, " 产品服务 "),
  /*#__PURE__*/_createElementVNode("div", { class: "en-title" }, " product service ")
], -1))
const _hoisted_5 = { class: "button-types" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "product-show" }
const _hoisted_8 = { class: "product-desc" }
const _hoisted_9 = { class: "txt-desc" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "iconfont icon-uav" }, null, -1))
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"product-capability\" data-v-f6b3c856><div class=\"capability-title\" data-v-f6b3c856><div class=\"zh-title\" data-v-f6b3c856> 产品能力 </div><div class=\"en-title\" data-v-f6b3c856> Product Capability </div></div><div class=\"img-desc\" data-v-f6b3c856><div class=\"img-two\" data-v-f6b3c856><div class=\"multiple-data\" data-v-f6b3c856><div class=\"img-title\" data-v-f6b3c856> “多”数据 </div><div class=\"img-title-desc\" data-v-f6b3c856> 支持不同相机类型和任意航迹的影像数据处理 </div></div><div class=\"high-precision\" data-v-f6b3c856><div class=\"img-title\" data-v-f6b3c856> “高”精度 </div><div class=\"img-title-desc\" data-v-f6b3c856> 基于像素单元的高精度全流程处理 </div></div></div><div class=\"img-three\" data-v-f6b3c856><div class=\"full-automatic\" data-v-f6b3c856><div class=\"img-title\" data-v-f6b3c856> “全”自动 </div><div class=\"img-title-desc\" data-v-f6b3c856> 一键式处理，无须人工干预，即可完成海量数据的生产 </div></div><div class=\"pure-scene\" data-v-f6b3c856><div class=\"img-title\" data-v-f6b3c856> “纯”场景 </div><div class=\"img-title-desc\" data-v-f6b3c856> 基于业务需求构建场景，打造可视化应用服务 </div></div><div class=\"true-products\" data-v-f6b3c856><div class=\"img-title\" data-v-f6b3c856> “真”产品 </div><div class=\"img-title-desc\" data-v-f6b3c856> 生产满足业务使用需求的行业应用产品 </div></div></div></div></div>", 1)

import { ref, } from 'vue';
import { useRouter, } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const buttonType = [
  {
    name: '正射影像',
    type: 'dom',
    text: '支持全自动化生成正射影像成果、DEM成果，提供可视化的成果展示。',
  },
  {
    name: '倾斜摄影',
    type: 'oblique',
    text: '提供三维实景构建服务，构建全空间的三维可视化场景。',
  },
  {
    name: '垃圾识别',
    type: 'rubbish',
    text: '提供高精度垃圾识别和提取服务，助力无废城市建设。',
  },
  {
    name: '土方计算',
    type: 'earthwork',
    text: '根据正射影像构建土方应用场景，科学化监督工程质量。',
  },
];

const router = useRouter();

// 了解详情按钮跳转
const jumpToPage = () => {
  window.open('https://engine.piesat.cn/engine-uav/#/newIndex');
};
// 选中的产品类型
const selectButton = ref('dom');
const changeSeleButton = (value: any) => {
  selectButton.value = value;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "uav-banner" }, [
      _createElementVNode("button", {
        class: "btn-to-detail",
        onClick: jumpToPage
      }, " 了解详情 ")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(buttonType, (item) => {
            return _createElementVNode("div", {
              key: item.type,
              class: _normalizeClass(`item ${selectButton.value === item.type ? 'active' : ''}`),
              onClick: ($event: any) => (changeSeleButton(item.type))
            }, _toDisplayString(item.name), 11, _hoisted_6)
          }), 64))
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: _normalizeClass(`product-${selectButton.value}`)
        }, null, 2),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(buttonType.find(item => item.type === selectButton.value)?.text), 1),
          _hoisted_10
        ])
      ])
    ]),
    _hoisted_11
  ]))
}
}

})